<div id="{{id}}" class="position-relative m-auto py-3" style="height: 194px;"> 
  <app-doughnut-chart [SalesTrendsData]="chartDataSet" [id]="id" [data]="salesTrendsChartData" [chartColors]="doughnutChartColors" ></app-doughnut-chart>     
</div>